import { RequestDataDto } from "@app/core/dto/request-data.dto";
import { ActionCommand } from "../action-command-interface";
import { ActionCommandResponseDto } from "@app/core/dto/action-command-response.dto";
import { SearchPayloadDto, SearchRequestDto } from "@app/core/dto/abstract-action.dto";
import { LOGIN_MODE } from "@app/core/enums/login/login-mode.enum";
import { SOCIAL_LOGIN_MODE } from "@app/core/enums/login/social-login-mode.enum";
import { ModuleType } from "@app/core/enums/module-type.enum";

export class LoginCommand implements ActionCommand {
  constructor(private renderEngineComponent: any) { }

  async execute(actionData: any, requestData: RequestDataDto): Promise<ActionCommandResponseDto> {
    const formattedAction: SearchRequestDto = new SearchRequestDto();
    formattedAction.action = actionData?.type;

    const payload = { ...actionData?.params };
    formattedAction.payload = new SearchPayloadDto(payload);
    requestData.updatedAction = { ...formattedAction };
    requestData.finalData.userContext = requestData?.updatedAction;

    if (actionData?.mode === LOGIN_MODE.SOCIAL) {
      const socialLoginMode: SOCIAL_LOGIN_MODE = actionData?.params?.type;
      const loginToken:string = await this.renderEngineComponent.firebaseService.login(socialLoginMode);
      requestData.finalData.userContext.payload.loginToken = loginToken;
      requestData.finalData.userContext.payload.verificationType = actionData?.mode;
    }
    requestData.module = ModuleType.USER;
    return new ActionCommandResponseDto({
      shouldFetchData: true,
      requestData: requestData
    })
  }
}